<template>
  <el-drawer
    v-if="visible"
    :visible="visible"
    :title="title || $l('dialog_title_update_sku') || '修改SKU'"
    show-close
    :size="1000"
    direction="rtl"
    :before-close="() => $refs.main.cancel()"
    :wrapper-closable="true"
    :modal-append-to-body="false"
    :modal="true"
  >
    <div class="drawer-main">
      <Main
        ref="main"
        @reload="$emit('reload')"
        @close="close()"
        :storeCode="storeCode"
        :disabled="disabled"
        :amzSkuStoreCode="amzSkuStoreCode"
      />
    </div>
    <div class="drawer-footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!disabled"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
  </el-drawer>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    storeCode: { type: String, default: '' },
    title: { type: String, default: '' },
    amzSkuStoreCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-drawer__header {
  margin-bottom: 10px !important;
}
</style>
